import React from 'react';

import { DocumentFilterOptionSchema, DocumentKind } from '@app/models/wms';
import Api from '@app/services/api';

import { BaseDocumentFilterSelect, DocumentFilterSelectBaseProps } from './BaseDocumentFilterSelect';

interface IProps extends DocumentFilterSelectBaseProps {
  kind: 'shipment' | 'receipt';
  warehouseUid: string;
}

export const SenderDocumentFilterSelect: React.FC<IProps> = ({ kind, warehouseUid, ...props }) => {
  const [options, setOptions] = React.useState<DocumentFilterOptionSchema[]>([]);
  const [fetching, setFetching] = React.useState(false);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    const fetchOptions = async (): Promise<void> => {
      if (!warehouseUid) {
        setOptions([]);
        return;
      }

      setFetching(true);
      setError(false);

      await Api.wms
        .getWarehouseDocumentsSenders(warehouseUid, kind as DocumentKind)
        .then(setOptions)
        .catch(() => setError(true))
        .finally(() => setFetching(false));
    };

    fetchOptions();
  }, [kind, warehouseUid]);

  return <BaseDocumentFilterSelect {...props} error={error} fetching={fetching} options={options} />;
};
